export const changeTexture = function(item, newTex, slotName = 'face_texture.jpg') {
    if (!item || !item.material) return;
    if (item.material.nodeTextures) {
        for (let name in item.material.nodeTextures) {
            if (item.material.nodeTextures[name].name === slotName) {
                newTex.encoding = item.material.nodeTextures[name].encoding;
                newTex.wrapS = item.material.nodeTextures[name].wrapS;
                newTex.wrapT = item.material.nodeTextures[name].wrapT;
                newTex.anisotropy = item.material.nodeTextures[name].anisotropy;

                item.material.nodeTextures[name] = newTex;
            }
        }
    }
    item.material.needsUpdate = true;
};


export const changeTextureCustom = function(item, oldName, newTex) {
    if (!item || !item.material) return;
    if (item.material.nodeTextures) {
        for (let name in item.material.nodeTextures) {
            if (item.material.nodeTextures[name].name === oldName) {
                newTex.encoding = item.material.nodeTextures[name].encoding;
                newTex.wrapS = item.material.nodeTextures[name].wrapS;
                newTex.wrapT = item.material.nodeTextures[name].wrapT;
                newTex.anisotropy = item.material.nodeTextures[name].anisotropy;

                item.material.nodeTextures[name] = newTex;
            }
        }
    }
    item.material.needsUpdate = true;
};
